import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../api/client';

const QuestsPage: React.FC = () => {
  const { token } = useAuth();
  const [questId, setQuestId] = useState('');
  const [msg, setMsg] = useState<string | null>(null);

  const claim = async () => {
    setMsg(null);
    try {
      const res = await api.post<{ ok: boolean; quest: any }>(`/quests/${questId}/claim`, undefined, token!);
      setMsg(`Quest claimed: ${res.quest.title}`);
    } catch (err: any) {
      setMsg(err?.message || 'Claim failed');
    }
  };

  return (
    <div className="space-y-6">
      <div className="p-5 rounded-xl bg-gray-900/70 border border-gray-800">
        <h2 className="text-xl font-semibold flex items-center gap-2"><i className="fas fa-scroll text-pink-400"></i> <span>Quests</span></h2>
        <div className="mt-3 flex gap-2">
          <input className="flex-1 px-3 py-2 rounded bg-gray-800 text-white" placeholder="Quest ID" value={questId} onChange={(e) => setQuestId(e.target.value)} />
          <button className="px-4 py-2 rounded bg-green-600 hover:bg-green-500" onClick={claim}>Claim</button>
        </div>
        {msg && <div className="mt-2 text-sm text-gray-300">{msg}</div>}
      </div>
    </div>
  );
};

export default QuestsPage;